import React from "react";
import { motion } from "framer-motion";
import JeaCard from "@/components/jea/JeaCard";

/**
 * Empty state used by dashboard placeholder and every not-yet-built sidebar item.
 * Follows the spec: 48px pink icon, white heading, silver-blue subtext.
 */
const EmptyState = ({ icon: Icon, title, description, footer = null, testid = "empty-state" }) => {
  return (
    <JeaCard className="min-h-[420px] flex items-center justify-center text-center" data-testid={testid}>
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
        className="max-w-md flex flex-col items-center gap-4"
      >
        <div
          className="w-16 h-16 rounded-full bg-accent-pink/10 border border-accent-pink/30 flex items-center justify-center"
          aria-hidden
        >
          {Icon ? <Icon size={28} className="text-accent-pink" strokeWidth={2} /> : null}
        </div>
        <h2 className="text-[18px] font-semibold text-white">{title}</h2>
        {description && (
          <p className="text-[14px] text-text-secondary leading-6">{description}</p>
        )}
        {footer}
      </motion.div>
    </JeaCard>
  );
};

export default EmptyState;
